import type { Providers } from 'generated/graphql'
import type { TCustomerioUsedFeature } from 'lib/customerio-tracker/customerio-tracker.types'
import { PanelStore, UserStore } from 'stores'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import { ENTITY_TYPE_TO_CUSTOMER_IO } from './niche.consts'

export const getNicheFeatureByEntityType = (entityType: string): TCustomerioUsedFeature => {
  return ENTITY_TYPE_TO_CUSTOMER_IO[entityType] ?? ENTITY_TYPE_TO_CUSTOMER_IO['topics']
}

export const getNicheUrl = (territoryId: string) => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.id
  const url = getRoute(PATHNAMES.WORKSPACE_NICHE, {
    entityId: territoryId,
    panelId: workspaceId,
    tab: 'overview',
  })
  return url
}

export const getCategoryUrl = (territoryId: string) => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.id
  const url = getRoute(PATHNAMES.INDUSTRY_CATEGORY, {
    entityId: territoryId,
    panelId: workspaceId,
  })
  return url
}

export const getScopedNicheUrl = (categoryId: string, nicheId: string) => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.id
  const url = getRoute(PATHNAMES.WORKSPACE_CATEGORY_NICHE, {
    categoryId,
    entityId: nicheId,
    panelId: workspaceId,
    tab: 'overview',
  })
  return url
}

export const getProviders = (searchParams: URLSearchParams) => {
  const providers = searchParams.getAll('providers') || []

  const baseProviders = UserStore?.providers as Providers[]
  const filteredProviders = providers.filter((provider: Providers) => baseProviders.includes(provider)) as Providers[]
  const finalProviders = filteredProviders.length ? filteredProviders : baseProviders

  return finalProviders
}
